import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32cb4556"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-flex is-flex-direction-row" }
const _hoisted_2 = ["href"]

import { inject } from "vue"

import Card from "./Card.vue"
import BulmaIcon from "@/components/common/BulmaIcon.vue"

type Props = {
  index: number,
  // Items should be limited to a maximum of 4
  source: { items: any[]},
  isWidget: boolean,
  dataInt?: string,
  openInNewTab?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualScrollCards',
  props: {
    index: {},
    source: {},
    isWidget: { type: Boolean },
    dataInt: {},
    openInNewTab: { type: Boolean }
  },
  setup(__props: any) {



//@ts-ignore
const { navToWidgetContent, select } = inject("eventHandlers")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.source.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "vs-card"
      }, [
        (_openBlock(), _createBlock(Card, {
          key: i,
          item: item,
          "is-widget": _ctx.isWidget,
          "data-int": _ctx.dataInt,
          onClick: _unref(select),
          onNavToWidget: _unref(navToWidgetContent)
        }, {
          header: _withCtx(() => [
            (_ctx.openInNewTab)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.path,
                  class: "is-small",
                  style: {"position":"absolute","top":"0","right":"0","z-index":"2"},
                  target: "_blank"
                }, [
                  _createVNode(BulmaIcon, { "icon-class": "fas fa-external-link-alt" })
                ], 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["item", "is-widget", "data-int", "onClick", "onNavToWidget"]))
      ]))
    }), 128))
  ]))
}
}

})